<div>
  <div class="dialog-heading">
    <h5>{{ data.title }}</h5>
    <span class="flex-fill"></span>
    <mat-icon class="close-dialog" aria-hidden="false" mat-dialog-close aria-label="Close icon">close</mat-icon>
  </div>
  <mat-dialog-content>
    <p [innerHTML]="data.message"></p>
  </mat-dialog-content>

  <mat-dialog-actions class="actions">
    <span class="flex-fill"></span>
    <button mat-flat-button color="accent" [mat-dialog-close]="true">Close</button>
    <span class="flex-fill"></span>
  </mat-dialog-actions>
</div>
